var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedWarningIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D13131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.829 4.571l-.177 5.474H7.069L6.892 4.57h1.937zm-.97 8a.974.974 0 01-.71-.292.965.965 0 01-.292-.71c0-.271.098-.504.293-.696a.973.973 0 01.708-.293c.265 0 .497.098.698.293a.927.927 0 01.304.697.93.93 0 01-.143.504 1.051 1.051 0 01-.366.363.936.936 0 01-.493.134z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarningIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/redWarningIcon.badd3b13.svg";
export { MemoForwardRef as ReactComponent };